var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as R from 'ramda';
import * as Yup from 'yup';
import Moment from 'moment';
import { mapFormDefFlatten, FORMULA_ELEMENT_MOCK } from './_.utils';
import { execFormula, execFormulaAsync } from './formula.utils';
import { XbpmFormulaType } from '../../models/xbpm.enums';
// default yup validation messages
Yup.setLocale({
    number: {
        min: 'Значение должно быть не меньше ${min}',
        max: 'Значение должно быть не больше ${max}',
        moreThan: 'Значение должно быть больше ${more}',
        lessThan: 'Значение должно быть меньше ${less}',
    },
    string: {
        min: 'Длина текста меньше, чем минимально допустимая ${min} символов',
        max: 'Длина текста больше, чем максимально допустимая ${max} символов',
    },
    mixed: {
        notType: R.pipe(R.prop('type'), R.cond([
            [R.equals('number'), function () { return 'Значение поля должно быть числом'; }],
            [R.equals('string'), function () { return 'Значение поля должно быть строкой'; }],
            [R.equals('date'), function () { return 'Значение поля должно быть датой'; }],
            [R.T, R.identity],
        ])),
        required: 'Поле обязательно для заполнения!',
    },
});
Yup.addMethod(Yup.mixed, 'toDate', function (formats, parseStrict) {
    if (formats === void 0) { formats = 'DD.MM.YYYY'; }
    if (parseStrict === void 0) { parseStrict = false; }
    return this.transform(function (value, original) {
        if (this.isType(value)) {
            return value;
        }
        var date = Moment(original, formats, parseStrict);
        return date.isValid() ? date.toDate() : undefined;
    });
});
// form validation schema
var testYupSchemeEnv = __assign(__assign({}, Yup), FORMULA_ELEMENT_MOCK);
var testYupScheme = R.pipe(function (formula) { return execFormula(formula, testYupSchemeEnv, true); }, R.when(R.complement(Yup.isSchema), R.always(null)));
var transformValidator = function (validator) {
    if (validator instanceof Yup.date) {
        return validator['toDate']();
    }
    return validator;
};
var createCustomValidator = function (formula) { return function (it) {
    return Yup.mixed().test(it.id, undefined, function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, execFormulaAsync(formula, it)];
                case 1:
                    error = _a.sent();
                    return [2 /*return*/, !error || new Yup.ValidationError(error, value, it.id)];
            }
        });
    }); });
}; };
// validation frame
var mapElementValidationFrame = function (_a) {
    var frontFormulas = _a.frontFormulas;
    var formula = R.prop(XbpmFormulaType.VALIDATE, frontFormulas);
    var validator = formula ? testYupScheme(formula) : null;
    return !formula
        ? undefined
        : validator
            ? { kind: 'schema', validator: transformValidator(validator) }
            : { kind: 'custom', validator: createCustomValidator(formula) };
};
export var mapValidationFrame = mapFormDefFlatten(mapElementValidationFrame);
// validation schema
var isElementValidationSkipped = function (el) {
    return el.hidden || (el.parent ? isElementValidationSkipped(el.parent) : false);
};
var mapElementValidation = function (frame) { return function (el) {
    var elFrame = frame[el.id];
    return !elFrame || isElementValidationSkipped(el)
        ? undefined
        : elFrame.kind === 'custom'
            ? elFrame.validator(el)
            : elFrame.validator;
}; };
var mapValidationShapeFlatten = function (frame, form) {
    return mapFormDefFlatten(mapElementValidation(frame))(form);
};
export var mapValidationSchema = function (frame, form) {
    return Yup.object().shape(mapValidationShapeFlatten(frame, form));
};
// validation errors
var mergeValidationErrors = R.pipe(R.map(function (err) {
    var _a;
    return (_a = {}, _a[err.path] = err.message, _a);
}), R.uniq, R.mergeAll);
export var mapValidationErrors = function (yupError) {
    return !yupError || !yupError.inner ? {} : mergeValidationErrors(yupError.inner.length === 0 ? [yupError] : yupError.inner);
};
//# sourceMappingURL=validation.utils.js.map